module.exports = __webpack_public_path__ + "static/media/deleteIcons.eb534f27.svg";